export default "__VITE_ASSET__BsIoh2DdRfc6hjAKziqQ8g__"